var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _animate, _animate2, _animate3, _animate4, _animateTransform, _animate5, _animate6, _animate7, _animate8, _animate9, _animate0, _animate1, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18, _animate19, _animate20, _animate21, _animate22, _animate23, _animate24, _animate25, _animate26, _animate27, _animateTransform2, _animate28, _animate29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m17lmm5bqof1st96xq",
    viewBox: "0 0 1600 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m17lmm5bqof1st96xq_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmm5bqof1st96xq",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m17lmm5bqof1st96xq_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.01,0h1599.98c0.00552,0 0.01,0.00448 0.01,0.01v999.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-1599.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-999.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m17lmm5bqof1st96xq_clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m17lmm5bqof1st96xq_fill_path",
    d: "M0.01,0h1599.98c0.00552,0 0.01,0.00448 0.01,0.01v999.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-1599.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-999.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(245, 248, 250)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmc5772yftix4tr_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,176,-3.9999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmc5772yftix4tr",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmc5772yftix4tr_stroke_path",
    d: "M1315,0l-365.5,563l-63.5,-98l-141.5,218l-205.5,-316.5l-236.5,364.5l-61.5,-95l-241,371.5",
    fill: "none",
    stroke: "rgb(109, 138, 171)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmge38znbf2vtn4_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,84,-9.9999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmge38znbf2vtn4",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmge38znbf2vtn4_stroke_path",
    d: "M1490,0l-386.5,594.5l-58.5,-90l-187,289l-293,-451.5l-247.5,381l-63.5,-97.5l-254,391",
    fill: "none",
    stroke: "rgb(109, 138, 171)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmpngs7h35ey6o4_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,199.5,636.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmpngs7h35ey6o4",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmpngs7h35ey6o4_stroke_path",
    d: "M0,192.5l125,-192.5",
    fill: "none",
    stroke: "rgb(0, 45, 93)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmq349v2msnymyt_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,514.5,460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmq349v2msnymyt",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmq349v2msnymyt_stroke_path",
    d: "M0,79l51.5,-79",
    fill: "none",
    stroke: "rgb(0, 45, 93)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmrxk1hl01htyg9_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1036,494.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmrxk1hl01htyg9",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmrxk1hl01htyg9_stroke_path",
    d: "M0,143.5l93,-143.5",
    fill: "none",
    stroke: "rgb(0, 45, 93)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmsbpuz8gv9j7u8_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1302,283.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmsbpuz8gv9j7u8",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmsbpuz8gv9j7u8_stroke_path",
    d: "M0,124.5l81.5,-124.5",
    fill: "none",
    stroke: "rgb(0, 45, 93)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmumpvyvsbhyh4_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,499.5,612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmumpvyvsbhyh4",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmumpvyvsbhyh4_stroke_path",
    d: "M0,82.5l53.5,-82.5",
    fill: "none",
    stroke: "rgb(102, 212, 255)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmx21n8b6kty4rei_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,995.5,495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmx21n8b6kty4rei",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmx21n8b6kty4rei_stroke_path",
    d: "M0,68l44,-68",
    fill: "none",
    stroke: "rgb(102, 212, 255)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmmzz56v226p0x1g_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,344.5,632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmmzz56v226p0x1g",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmmzz56v226p0x1g_stroke_path",
    d: "M0,111l72,-111",
    fill: "none",
    stroke: "rgb(102, 212, 255)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m17lmn0cjt21tn2g8n_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1194.5,345.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m17lmn0cjt21tn2g8n",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m17lmn0cjt21tn2g8n_stroke_path",
    d: "M0,107l69.5,-107",
    fill: "none",
    stroke: "rgb(102, 212, 255)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  })))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmc5772yftix4tr_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 2439.9242;1128.163 1311.7612;1527.006 912.9182;1789.5998 650.3243;1978.5128 461.4114;2118.6272 321.2969;2222.9883 216.9358;2299.5681 140.356;2353.9229 86.0013;2389.6762 50.2479;2409.4855 30.4387;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577;2415.7665 24.1577",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmc5772yftix4tr_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-2415.7665;-1287.6036;-888.7605;-626.1667;-437.2537;-297.1393;-192.7782;-116.1984;-61.8436;-26.0903;-6.281;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmge38znbf2vtn4_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 2763.2009;0 2763.2009;0 2763.2009;1398.8363 1364.3646;1874.5993 888.6016;2176.6363 586.5646;2383.7396 379.4614;2528.4656 234.7353;2627.2295 135.9714;2690.7011 72.4998;2725.1727 38.0282;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584;2735.8425 27.3584",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmge38znbf2vtn4_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-2735.8425;-2735.8425;-2735.8425;-1337.0062;-861.2432;-559.2062;-352.1029;-207.3769;-108.6129;-45.1414;-10.6698;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#m17lmmjaom7caqi7aog_translate",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 0;0 15;0 15",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.08;0.16;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmjaom7caqi7aog",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.08;0.16;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmpngs7h35ey6o4_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;0 231.8192;49.646 182.1732;136.0159 95.8033;156.719 75.1002;160.6668 71.1524;204.7813 27.0379;190.6656 41.1536;184.7438 47.0754;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2;183.6192 48.2",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmpngs7h35ey6o4_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;-14.1846;-38.8584;-44.7801;-45.9048;-45.9048;-45.9048;-45.9048;-45.9048;-45.9048;-45.9048;-45.9048;-45.9048",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmpngs7h35ey6o4",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.34;0.36;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmq349v2msnymyt_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;0 95.2471;6.2995 88.9476;36.5994 58.6477;52.8008 42.4462;56.2806 38.9664;54.4794 40.7676;44.3795 50.8676;38.9853 56.2618;37.8253 57.4217;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255;37.7216 57.5255",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate0 || (_animate0 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmq349v2msnymyt_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;-6.2995;-36.5994;-52.8008;-56.2806;-56.5824;-56.5824;-56.5824;-56.5824;-56.5824;-56.5824;-56.5824;-56.5824",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate1 || (_animate1 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmq349v2msnymyt",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.36;0.38;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmrxk1hl01htyg9_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;0 172.7107;42.2714 130.4394;115.8188 56.8919;133.4319 39.2789;136.8006 35.9102;95.5894 77.1213;88.1167 84.5941;129.3279 43.3829;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102;136.8006 35.9102",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmrxk1hl01htyg9_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;-12.2608;-14.4838;-16.7068;-17.1001;-17.1001;-17.1001;-17.1001;-17.1001;-17.1001;-17.1001;-17.1001",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmrxk1hl01htyg9",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.38;0.4;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmsbpuz8gv9j7u8_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;0 150.2916;13.2435 137.0481;76.991 73.3006;111.0819 39.2097;118.4179 31.8737;112.4211 37.8705;80.5474 69.7442;63.4945 86.7971;59.8339 90.4577;59.5214 90.7702;59.5214 90.7702;59.5214 90.7702;59.5214 90.7702;59.5214 90.7702;59.5214 90.7702;59.5214 90.7702",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmsbpuz8gv9j7u8_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;-9.9401;-57.7507;-83.3151;-88.806;-89.2821;-89.2821;-89.2821;-89.2821;-89.2821;-89.2821;-89.2821",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmsbpuz8gv9j7u8",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.4;0.42;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmumpvyvsbhyh4_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;0 99.3118;27.3452 71.9667;74.9165 24.3953;86.3128 12.999;88.4957 10.8161;63.5202 35.7916;58.9971 40.3147;92.2912 7.0207;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833;98.3285 0.9833",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmumpvyvsbhyh4_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmumpvyvsbhyh4",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.4;0.42;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate19 || (_animate19 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmx21n8b6kty4rei_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;0 81.8038;6.3094 75.4943;36.674 45.1298;52.9052 28.8986;56.396 25.4078;53.9905 27.8133;40.9748 40.829;34.0174 47.7864;32.5271 49.2766;32.3975 49.4062;32.3975 49.4062;32.3975 49.4062;32.3975 49.4062;32.3975 49.4062;32.3975 49.4062;32.3975 49.4062",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate20 || (_animate20 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmx21n8b6kty4rei_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;-5.4104;-31.4337;-45.3484;-48.3371;-48.5963;-48.5963;-48.5963;-48.5963;-48.5963;-48.5963;-48.5963",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate21 || (_animate21 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmx21n8b6kty4rei",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.4;0.42;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate22 || (_animate22 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmzz56v226p0x1g_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;0 133.6295;28.6179 105.0116;78.4048 55.2247;90.3389 43.2907;92.6145 41.015;76.2614 57.3681;47.8156 85.814;41.0018 92.6278;39.6919 93.9376;39.6919 93.9376;39.6919 93.9376;39.6919 93.9376;39.6919 93.9376;39.6919 93.9376;39.6919 93.9376",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate23 || (_animate23 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmzz56v226p0x1g_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;-16.3531;-44.799;-51.6128;-52.9226;-52.9226;-52.9226;-52.9226;-52.9226;-52.9226;-52.9226",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate24 || (_animate24 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmmzz56v226p0x1g",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.42;0.44;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate25 || (_animate25 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmn0cjt21tn2g8n_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;0 128.8661;11.3555 117.5105;66.0152 62.8509;95.2461 33.62;101.5363 27.3298;90.8442 38.0219;66.6403 62.2257;80.9177 47.9484;113.619 15.247;114.8311 14.0349;114.8311 14.0349;114.8311 14.0349;114.8311 14.0349;114.8311 14.0349;114.8311 14.0349",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate26 || (_animate26 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmn0cjt21tn2g8n_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;-3.3429;-10.5389;-11.4066;-12.708;-12.759;-12.759;-12.759;-12.759;-12.759;-12.759",
    dur: "5s",
    repeatCount: 1,
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate27 || (_animate27 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m17lmn0cjt21tn2g8n",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.44;0.46;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#m1988owb03387698_translate",
    attributeName: "transform",
    type: "translate",
    values: "0 0;0 0;0 -20;0 -20",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.25;0.35;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animate28 || (_animate28 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m1988owb03387698",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.25;0.35;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate29 || (_animate29 = /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    href: "#m1988ows65552788",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: 1,
    calcMode: "spline",
    keyTimes: "0;0.12;0.26;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.af34ea449873d9bebe535c42b1a2e9f1.svg";
export { ForwardRef as ReactComponent };